var _g, _g2, _g3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionTypeWcImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 108,
    viewBox: "0 0 125 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 25.9497,
    y: 15.9189,
    width: 83.2247,
    height: 64.9945,
    rx: 2.77093,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.2059,
    y: 16.2547,
    width: 82.5512,
    height: 64.321,
    rx: 2.4342,
    stroke: "black",
    strokeWidth: 0.673465,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.3579,
    y: 54.3584,
    width: 39.6308,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.3579,
    y: 54.3584,
    width: 39.6308,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.3579,
    y: 54.3584,
    width: 39.6308,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.3579,
    y: 54.3584,
    width: 39.6308,
    height: 2.37785,
    rx: 1.18892,
    fill: "#9BBAC1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.9951,
    y: 63.4756,
    width: 39.6308,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.9951,
    y: 63.4756,
    width: 39.6308,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.9951,
    y: 63.4756,
    width: 39.6308,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.9951,
    y: 63.4756,
    width: 39.6308,
    height: 2.37785,
    rx: 1.18892,
    fill: "#9BBAC1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.9951,
    y: 34.9414,
    width: 39.6308,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.9951,
    y: 34.9414,
    width: 39.6308,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.9951,
    y: 34.9414,
    width: 39.6308,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.9951,
    y: 34.9414,
    width: 39.6308,
    height: 2.37785,
    rx: 1.18892,
    fill: "#E3DFE9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.9951,
    y: 27.8086,
    width: 39.6308,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.9951,
    y: 27.8086,
    width: 39.6308,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.9951,
    y: 27.8086,
    width: 39.6308,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.9951,
    y: 27.8086,
    width: 39.6308,
    height: 2.37785,
    rx: 1.18892,
    fill: "#9BBAC1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.2905,
    y: 34.9414,
    width: 20.608,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.2905,
    y: 34.9414,
    width: 20.608,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.2905,
    y: 34.9414,
    width: 20.608,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.2905,
    y: 34.9414,
    width: 20.608,
    height: 2.37785,
    rx: 1.18892,
    fill: "#9BBAC1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.6685,
    y: 27.8086,
    width: 20.608,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.6685,
    y: 27.8086,
    width: 20.608,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.6685,
    y: 27.8086,
    width: 20.608,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.6685,
    y: 27.8086,
    width: 20.608,
    height: 2.37785,
    rx: 1.18892,
    fill: "#E3DFE9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.4839,
    y: 41.2832,
    width: 22.9859,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.4839,
    y: 41.2832,
    width: 22.9859,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.4839,
    y: 41.2832,
    width: 22.9859,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.4839,
    y: 41.2832,
    width: 22.9859,
    height: 2.37785,
    rx: 1.18892,
    fill: "#E3DFE9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.2905,
    y: 46.8311,
    width: 22.9859,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.2905,
    y: 46.8311,
    width: 22.9859,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.2905,
    y: 46.8311,
    width: 22.9859,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.2905,
    y: 46.8311,
    width: 22.9859,
    height: 2.37785,
    rx: 1.18892,
    fill: "#E3DFE9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.6401,
    y: 41.2832,
    width: 22.9859,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.6401,
    y: 41.2832,
    width: 22.9859,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.6401,
    y: 41.2832,
    width: 22.9859,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.6401,
    y: 41.2832,
    width: 22.9859,
    height: 2.37785,
    rx: 1.18892,
    fill: "#9BBAC1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.6772,
    y: 53.9648,
    width: 26.9489,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.6772,
    y: 53.9648,
    width: 26.9489,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.6772,
    y: 53.9648,
    width: 26.9489,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.6772,
    y: 53.9648,
    width: 26.9489,
    height: 2.37785,
    rx: 1.18892,
    fill: "#E3DFE9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.2905,
    y: 62.6836,
    width: 22.9859,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.2905,
    y: 62.6836,
    width: 22.9859,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.2905,
    y: 62.6836,
    width: 22.9859,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.2905,
    y: 62.6836,
    width: 22.9859,
    height: 2.37785,
    rx: 1.18892,
    fill: "#E3DFE9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.23047 57.0604L76.6078 17.7734L8.23047 57.0604Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.698 33.2878L116.027 30.1855L110.698 33.2878Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.728 87.5973L55.0571 84.4951",
    stroke: "#E3DFE9",
    strokeWidth: 16.7314,
    strokeLinecap: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.261 76.6241C114.093 76.711 114.698 77.4567 114.611 78.2884C114.524 79.1201 113.778 79.7249 112.947 79.638C112.115 79.5512 111.51 78.8054 111.597 77.9737C111.684 77.1421 112.43 76.5373 113.261 76.6241Z",
    stroke: "#8E8E8E",
    strokeWidth: 0.778901
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6202 94.0605C32.9878 94.2033 33.9823 95.4296 33.8395 96.7973C33.6967 98.1649 32.4703 99.1594 31.1027 99.0166C29.735 98.8738 28.7406 97.6475 28.8834 96.2798C29.0262 94.9122 30.2525 93.9177 31.6202 94.0605Z",
    stroke: "#8E8E8E",
    strokeWidth: 1.28085
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7515 6.05561C61.1192 6.1984 62.1136 7.42477 61.9708 8.79241C61.828 10.1601 60.6017 11.1545 59.234 11.0117C57.8664 10.869 56.8719 9.64259 57.0147 8.27494C57.1575 6.9073 58.3839 5.91281 59.7515 6.05561Z",
    stroke: "#8E8E8E",
    strokeWidth: 1.28085
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.06599 37.8271C2.6942 37.8271 3.20425 38.3372 3.20425 38.9654C3.20425 39.5936 2.6942 40.1037 2.06599 40.1037C1.43779 40.1037 0.927734 39.5936 0.927734 38.9654C0.927734 38.3372 1.43779 37.8271 2.06599 37.8271Z",
    stroke: "#8E8E8E",
    strokeWidth: 0.936249
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122.616 30.3262C123.244 30.3262 123.755 30.8362 123.755 31.4644C123.755 32.0926 123.244 32.6027 122.616 32.6027C121.988 32.6027 121.478 32.0926 121.478 31.4644C121.478 30.8362 121.988 30.3262 122.616 30.3262Z",
    stroke: "#8E8E8E",
    strokeWidth: 0.936249
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M103.459 5.0293L104.759 0.649251",
    stroke: "#4D5762",
    strokeWidth: 0.545506
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M101.992 2.21973L106.372 3.51914",
    stroke: "#4D5762",
    strokeWidth: 0.545506
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.68164 79.6113L7.82088 75.1869",
    stroke: "#4D5762",
    strokeWidth: 0.545506
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1123 76.8574L9.53672 77.9967",
    stroke: "#4D5762",
    strokeWidth: 0.545506
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M101.652 99.377L102.543 94.896",
    stroke: "#4D5762",
    strokeWidth: 0.545506
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9326 96.7148L104.414 97.6059",
    stroke: "#4D5762",
    strokeWidth: 0.545506
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionTypeWcImg);
export default __webpack_public_path__ + "static/media/question_type_wc_img.025616b6f502157337cc3a270009ffcf.svg";
export { ForwardRef as ReactComponent };